import { round } from 'lodash-es';
import { getFormattedImageUrl } from './getFormattedImageUrl';
export var shouldCropThumbnailImage = function (thumbnailImage, maxWidth) {
    var isPortrait = thumbnailImage.height > thumbnailImage.width;
    return isPortrait && thumbnailImage.width > maxWidth;
};
export var getThumbnailImageUrl = function (thumbnailImage, maxWidth, containerAspectRatio) {
    if (!thumbnailImage || !thumbnailImage.url) {
        return null;
    }
    var shouldCrop = shouldCropThumbnailImage(thumbnailImage, maxWidth);
    var maxHeight = maxWidth / containerAspectRatio;
    var cropAspectRatio = maxHeight < thumbnailImage.height ? maxWidth + ":" + maxHeight : '1:1';
    return (getFormattedImageUrl({
        url: thumbnailImage.url,
        width: maxWidth,
        cropParams: shouldCrop ? ',offset-x0,offset-y0' : '',
        aspectRatio: shouldCrop ? cropAspectRatio : '',
    }) || null);
};
// Thumbnail padding utils
var MAX_IMAGE_PADDING = 0.05;
export var getThumbnailImagePadding = function (thumbnailImage, containerAspectRatio) {
    if (!thumbnailImage || !thumbnailImage.url) {
        return 0;
    }
    var imageAspectRatio = thumbnailImage.width / thumbnailImage.height;
    var imagePaddingPercent = round(1 - containerAspectRatio / imageAspectRatio, 2);
    return imageAspectRatio > containerAspectRatio
        ? Math.min(MAX_IMAGE_PADDING, imagePaddingPercent) * 100 + "%"
        : null;
};
